module.exports = __webpack_public_path__ + "img/D201706_2.962c9eea.jpg";